import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  GetPastDueInvoiceAlertsRequest,
  GetPastDueInvoiceAlertsResult,
} from './getPastDueInvoiceAlerts.types';

export async function getPastDueInvoiceAlerts({
  organizationId,
}: GetPastDueInvoiceAlertsRequest): Promise<GetPastDueInvoiceAlertsResult> {
  const response = await axiosInstance.get<GetPastDueInvoiceAlertsResult>(
    '/invoices/alerts/PastDueInvoices',
    {
      headers: {
        'X-Organization-Id': organizationId,
      },
    }
  );
  return response.data;
}
